import type { AddNewDataFormValues } from "@/modules/add-new-data/lib/schema";
import { useWebAdapter } from "@/web-adapter";

export type BarangayLocationSettings = Pick<
  AddNewDataFormValues["household"],
  | "province"
  | "provinceCode"
  | "municipality"
  | "municipalityCode"
  | "barangay"
  | "barangayCode"
>;

type SettingsState = {
  location: BarangayLocationSettings;
  locationLocked: boolean;
};

type ActiveWebAdapter = ReturnType<typeof useWebAdapter>;

let activeWebAdapter: ActiveWebAdapter | null = null;

export function useSettingsStore<T>(selector: (state: SettingsState) => T) {
  const web = useWebAdapter();
  activeWebAdapter = web;

  return selector({
    location: web.location,
    // Barangay Encoder owns exactly one Barangay-scoped online workspace.
    // Municipality/City data-entry remains selectable through the web front-page adapter.
    locationLocked: web.recordCreatePath === "/barangay/records",
  });
}

export function getActiveWebAdapter() {
  if (!activeWebAdapter) {
    throw new Error("The RBIM web questionnaire adapter is not ready.");
  }

  return activeWebAdapter;
}
